<template>
  <div class="selected-lpo" v-if="lpo">
    <CurrentLpoHeader />

    <div class="selected-lpo__content-container">
      <div class="selected-lpo__content">
        <router-view />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations, mapActions } from "vuex";
import CurrentLpoHeader from "./CurrentLpo__header";

export default {
  name: "SelectedLpoData",

  components: {
    CurrentLpoHeader,
  },

  computed: {
    lpo() {
      return this.$store.state.selectedLpo.lpo;
    },

    ...mapState("lpoData", {
      currentLpo: (state) => state.currentLpo,
    }),
  },

  methods: {
    ...mapActions("selectedLpo", ["getLpoAll"]),
    ...mapMutations("selectedLpo", ["clearLpo"]),
    ...mapActions("selectedLpo/recount", ["getRecount"]),
  },

  created() {
    const lpo_id = this.currentLpo.lpo_id;
    this.getLpoAll(lpo_id).then((res) => {
      this.getRecount();
    });
  },
  beforeDestroy() {
    this.clearLpo();
  },
};
</script>

<style scoped lang="scss" src="@/style/constants.scss"></style>

<style lang="scss" scoped>
@import "@/style/constants.scss";

.selected-lpo {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.selected-lpo__content-container {
  overflow-y: auto;
  flex: 1;
}

.selected-lpo__content {
  max-width: $wrapper-max-width;
  margin: auto;

  padding: $wrapper-padding;
}
</style>
